<script>
import LucideIcon from 'dashboard/components/LucideIcon.vue';

export default {
  components: {
    LucideIcon
  },
  props: {
    to: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    count: {
      type: String,
      default: '',
    },
    isChildMenuActive: {
      type: Boolean,
      default: false,
    },
    openInNewPage: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {};
  },
  computed: {
    safeName() {
      return this.name && typeof this.name === 'string' ? this.name : '';
    },
    sidebarTranslationKey() {
      return this.safeName ? `SIDEBAR.${this.safeName}` : 'SIDEBAR.UNKNOWN';
    },
    iconSize() {
      // You'll need to detect screen size, for example using window.innerWidth
      // or a reactive screen size composable
      const width = window.innerWidth;
      if (width >= 1024) return 24; // lg+
      if (width >= 640) return 32;  // sm, md
      return 24; // mobile
    }
  },
  methods: {},
};
</script>

<template>
  <router-link v-slot="{ href, isActive, navigate }" :to="to" custom>
    <a
      v-tooltip.right="safeName ? $t(sidebarTranslationKey) : ''"
      :href="href"
      class="relative flex items-center justify-center size-10 sm:size-[3.75rem] lg:size-10 rounded-lg text-n-slate-11 dark:text-n-slate-11 transition-colors duration-150"
      :class="{
        'bg-hilab text-white': isActive || isChildMenuActive,
        'hover:bg-n-solid-3 dark:hover:bg-n-solid-3': !(isActive || isChildMenuActive),
      }"
      :rel="openInNewPage ? 'noopener noreferrer nofollow' : undefined"
      :target="openInNewPage ? '_blank' : undefined"
      @click="navigate"
    >
      <LucideIcon
        :name="icon || 'settings'"
        :size="24"
        class="icon-responsive"
      />
      <span class="sr-only">{{ name }}</span>
      <span
        v-if="count"
        class="absolute bg-yellow-500 text-black-900 -top-1 -right-1"
      >
        {{ count }}
      </span>
    </a>
  </router-link>
</template>

<style scoped>
.icon-responsive {
  width: 1.5rem;
  height: 1.5rem;
}

@media (min-width: 640px) and (max-width: 1023px) {
  .icon-responsive {
    width: 2rem;
    height: 2rem;
  }
}
</style>